import { useCallback } from 'react';
import { Theme } from 'react-select';

type DropdownAPI = {
  setTheme: (theme: Theme) => Theme;
};

const useDropdownAPI = (): DropdownAPI => {
  const setTheme = useCallback((theme: Theme): Theme => ({
    ...theme,
    borderRadius: 4,
    spacing: {
      baseUnit: 0,
      controlHeight: 28,
      menuGutter: 8,
    },
    colors: {
      ...theme.colors,
      // ToDo: https://jira.tennisi.it/browse/CP-201
      primary25: 'var(--shape-50)',
      primary50: 'var(--shape-50)',
    },
  }), []);

  return {
    setTheme,
  };
};

export default useDropdownAPI;
